import React, { useMemo, useState, createContext, useEffect, useRef } from "react";
import Contexto from "./comun/Contexto";
import { BrowserRouter, Routes, Route} from "react-router-dom";

import SismoSentido from "./SismoSentido";
import ResMapa from "./resultados/ResMapa";

export default function SismoSentidoWrapper() {        
    const [cargando, setCargando] = useState(true);
    
    const valueRef = useRef({});
        
    useEffect(() => {
        fetch('config.json').then(response => {
            if (!response.ok) {
                throw new Error("Error cargando la configuracion " + response.status);
            }
    
            return response.json();
        }).then(json => {            
            valueRef.current = json;          
            setCargando(false)
        }).catch(function (e) {
            throw new Error("Error cargando la configuracion " + e);
            this.dataError = true;
        })
    }, []);
 
    if (cargando) {
        return <div>Cargando...</div>    
    }
    else return (       
        <Contexto.Provider value={valueRef.current}>
            <SismoSentido/>
        </Contexto.Provider>
    )
}